<template>
  <div class="wrapper">
    <Sidebar v-if="!$route.meta.hideSidebar" />
    <div id="content" :class="{ 'content-full-width': $route.meta.hideSidebar }">
      <NavBar v-if="!$route.meta.hideNavbar" />
      <slot />
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/layout/NavBar.vue'
import Sidebar from '@/components/layout/Sidebar.vue'

export default {
  name: 'DefaultLayout',
  components: {
    NavBar,
    Sidebar
  }
}
</script>

<style scoped>
#content.content-full-width {
  width: 100%;
}
</style>
